module.exports = __webpack_public_path__ + "static/media/logo2.60938009.svg";